// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3HMI8","resendInfoText":"OnGoingPaymentBox_resendInfoText__1jqfd"};